import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers';

import HdpContentWrapper from 'app/shared/modules/hdp/HdpContentWrapper';
import { highlightKeywords } from './controller';
import { DescriptionText } from './styles';

const HdpDescription: React.FC = React.memo(function HdpDescription() {
  const filterKeywords = useSelector((state: RootReduxState) => state.filter.keywords);
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails.currentListing);
  const active = listing?.active;
  const displayName = listing?.displayName;
  const fullDescription = listing?.details?.fullDescription;
  const hideStreet = listing?.address?.hideStreet;
  const isExpired = !active;

  const descriptionHtml = useCallback(() => {
    return highlightKeywords({
      filterKeywords,
      fullDescription,
    });
  }, [filterKeywords, fullDescription]);

  if (!fullDescription) {
    return null;
  }

  return (
    <HdpContentWrapper
      active={isExpired}
      collapsable
      header={`About ${hideStreet ? 'this listing' : displayName}`}
      headerHtmlTag="h2"
    >
      <DescriptionText
        dangerouslySetInnerHTML={{
          __html: descriptionHtml(),
        }}
        id="HdpDescriptionContent"
      />
    </HdpContentWrapper>
  );
});

export default HdpDescription;
